export enum Orientation {
  Square,
  Portrait,
  Landscape
}
